import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { BiSubdirectoryRight } from 'react-icons/bi'
import moment from 'moment/moment'
import { MdOutlineDone, MdClose } from 'react-icons/md'
import { Table } from 'rsuite'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'

const { Column, HeaderCell, Cell } = Table
const CompactCell = props => <Cell {...props} style={{ padding: 6 }} />
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />

// define locales for this page
const transFiles = ['dashboard']

export const PromotionEnergySourceApplicationPipesTable = (props) => {
  // for translation
  const { t } = useTranslation(transFiles)
  // get data
  const data = _.get(props, 'data', [])

  // format data for table
  const tableData = useMemo(() => {
    // if not data set...
    if (_.isEmpty(data)) { return [] }
    // format data
    return data.map((channel) => {
      channel.icon = <BiSubdirectoryRight size={20}/>
      // get date information
      const locale = window.user.user_language_id
      // set timestamps
      channel.updated = moment(channel.updated_at, 'YYYY-MM-DD').locale(locale).format('YYYY.MM.DD')
      channel.created = moment(channel.created_at, 'YYYY-MM-DD').locale(locale).format('YYYY.MM.DD')
      // get flag is active
      const isActive = _.get(channel, 'promotion_energy_application_pipe_is_active', 0)
      // eslint-disable-next-line no-constant-condition
      channel.is_active = isActive === 1 ? <MdOutlineDone /> : <MdClose />
      // add units to cost
      channel.ua_string = `${channel.promotion_energy_application_pipe_ua_watts}W/K`
      channel.reference_temperature_string = `${channel.promotion_energy_application_pipe_reference_temperature}º`
      // return sensor formatted
      return channel
    })
  }, [data])

  return (<>
    <Table hover={false} autoHeight={true} data={tableData} cellBordered rowHeight={30} headerHeight={30} >
      <Column width={50} align="center" fixed>
        <CompactHeaderCell></CompactHeaderCell>
        <CompactCell dataKey="no_data" />
      </Column>
      <Column width={50} align="center" fixed>
        <CompactHeaderCell>-</CompactHeaderCell>
        <CompactCell dataKey="icon" />
      </Column>
      <Column width={50} align="center" fixed>
        <CompactHeaderCell>C. Id</CompactHeaderCell>
        <CompactCell dataKey="promotion_energy_application_pipe_id" />
      </Column>
      <Column minWidth={300} flexGrow={1} align="left">
        <CompactHeaderCell>{t('dashboard.channel_distribution')}</CompactHeaderCell>
        <CompactCell dataKey="promotion_energy_application_pipe_name" />
      </Column>
      <Column width={140} align="center">
        <CompactHeaderCell>{t('dashboard.ua')}<sub>n</sub></CompactHeaderCell>
        <CompactCell dataKey="ua_string" />
      </Column>
      <Column width={140} align="center">
        <CompactHeaderCell>{t('dashboard.reference_temperature')}</CompactHeaderCell>
        <CompactCell dataKey="reference_temperature_string" />
      </Column>
      <Column width={140} align="center" fixed>
        <CompactHeaderCell>{t('dashboard.type')}</CompactHeaderCell>
        <CompactCell dataKey="promotion_energy_application_pipe_type_name" />
      </Column>
      <Column width={50} align="center">
        <CompactHeaderCell>{t('dashboard.active')}</CompactHeaderCell>
        <CompactCell dataKey="is_active" />
      </Column>
      <Column width={90} align={'center'}>
        <CompactHeaderCell>{t('dashboard.updated_at')}</CompactHeaderCell>
        <CompactCell dataKey="updated" />
      </Column>
      <Column width={90} align={'center'}>
        <CompactHeaderCell>{t('dashboard.created_at')}</CompactHeaderCell>
        <CompactCell dataKey="created" />
      </Column>
    </Table>
  </>)
}

PromotionEnergySourceApplicationPipesTable.propTypes = {
  data: PropTypes.array.isRequired
}
